import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Facebook, Youtube } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import Logo from "@/components/Logo";

export default function Footer() {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  const social = site?.social || {};

  return (
    <footer
      data-testid={FOOTER.root}
      className="mt-24 border-t border-white/10 bg-[#0a1222]/70"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-3">
        <div>
          <Logo size={140} />
          <p className="mt-4 max-w-sm text-sm text-gray-400">
            Broadcasting live weather, storm tracking, and severe weather coverage across the Peach State — 24 hours a day, 7 days a week.
          </p>
        </div>

        <div>
          <div className="font-oswald text-xs uppercase tracking-[0.3em] text-gray-400">Coverage</div>
          <ul className="mt-3 space-y-1 text-sm text-gray-300">
            <li>Atlanta · Savannah · Augusta</li>
            <li>Macon · Columbus · Athens</li>
            <li>North Georgia Mountains</li>
            <li>Coastal Georgia & Golden Isles</li>
          </ul>
        </div>

        <div>
          <div className="font-oswald text-xs uppercase tracking-[0.3em] text-gray-400">Follow</div>
          <div className="mt-3 flex items-center gap-3">
            <a
              href={social.facebook || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={FOOTER.fb}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:border-white/40 hover:bg-white/5 transition-colors"
            >
              <Facebook className="h-5 w-5" />
            </a>
            <a
              href={social.twitter || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={FOOTER.x}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:border-white/40 hover:bg-white/5 transition-colors"
              aria-label="X (Twitter)"
            >
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a
              href={social.youtube || "#"}
              target="_blank"
              rel="noreferrer"
              data-testid={FOOTER.yt}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:border-white/40 hover:bg-white/5 transition-colors"
            >
              <Youtube className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5 py-4 text-center text-xs text-gray-500">
        © {new Date().getFullYear()} Georgia Weather Network · All rights reserved · Weather data by NWS
      </div>
    </footer>
  );
}
